
import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import LogIn from "./app/auth/LogIn";
import Register from "./app/auth/Register";
import Dashboard from './app/pages/dashboard/Dashboard';
import SubmitResearch from './app/pages/research/SubmitResearch';
import SubmitProject from './app/pages/projects/SubmitProject';
import Projects from './app/pages/projects/Projects';
import ProjectDetails from './app/pages/projects/ProjectDetails';
import SubmitProduct from './app/pages/products/SubmitProduct';
import Products from './app/pages/products/Products';


import { ThemeProvider, createTheme } from '@mui/material/styles';
import ProductDetails from './app/pages/products/ProductDetails';
import ResearchThemes from './app/pages/research/ResearchThemes';
import Institutions from './app/pages/research/Institutions';
import Researchers from './app/pages/research/Researchers';
import Researches from './app/pages/research/Researches';
import ResearchDetails from './app/pages/research/ReseachDetails';
import ForgotPassword from './app/auth/ForgetPassword';
import ResetPassword from './app/auth/ResetPassword';
import Profile from './app/pages/navigation/Profile';
import ResearchViewAll from './app/pages/research/ResearchViewAll';
import ValidateEmail from './app/auth/validate-email';
import FeedbackAndSuggestions from './app/pages/more/FeedbackAndSuggestions';
import Testimonials from './app/pages/more/Testimonials';
import ContactUs from './app/pages/more/ContactUs';
import GeneralResources from './app/pages/more/GeneralResources';
import NotFoundPage from './app/components/NotFoundPage';
import SubmitPublished from './app/pages/publications/SubmitPublished';
import MyPublications from './app/pages/publications/MyPublications';
import Publications from './app/pages/publications/Publications';

const theme = createTheme({
	palette: {
		primary: {
			main: '#1976d2',
			light: '#fff',
		},
		secondary: {
			main: '#dc004e',
		},
		success: {
			light: '#4caf50',
			main: '#2e7d32',
			// main:'#074900',
			contrastText: '#fff',
		},
		info: {
			light: '#2196f3',
			main: '#1976d2',
			contrastText: '#fff',
		},

		background: {
			default: '#f5f5f5',
			paper: '#fff'
		},
		custom:{
			primaryColor:'#074900',
			greenColor:'#1b7132',
			redColor:'#c91940',
			cardColor:'#1369D3',
			blueColor:'#0d4991',
			yellowColor:'#ffb63a',

		}
	},
});

function App() {
	return (
		<SnackbarProvider
		maxSnack={3}
		anchorOrigin={{
			vertical: 'top',
			horizontal: 'right',
		}}>
        {/* <Router basename='user' > */}
		<ThemeProvider theme={theme}>
			<Router>
				<Routes>
						<Route path="/" element={<LogIn/>} />
						<Route path="/register" element={<Register />} />
						<Route path="/forget-password" element={<ForgotPassword />} />
						<Route path="/reset-password" element={<ResetPassword />} />
						<Route path="/validate-email" element={<ValidateEmail />} />
						<Route path="/validate-email/:token" element={<ValidateEmail />} />
						<Route path="/dashboard" element={<Dashboard/>} />

						<Route path="/researches" element={<Researches />} />
						<Route path="/research-details" element={<ResearchDetails/>} />
						<Route path="/research-submit" element={< SubmitResearch />} />
						<Route path="/research-views" element={< ResearchViewAll />} />

						<Route path="/publications" element={<Publications />} />
						<Route path="/my-publications" element={<MyPublications />} />
						<Route path="/submit-publications" element={< SubmitPublished />} />



						<Route path="/project-submit" element={< SubmitProject />} />
						<Route path="/projects" element={< Projects />} />
						<Route path="/project-details" element={< ProjectDetails />} />

						<Route path="/products" element={< Products />} />
						<Route path="/product-details" element={< ProductDetails />} />
						<Route path="/product-submit" element={< SubmitProduct />} />

						<Route path="/themes" element={< ResearchThemes />} />
						<Route path="/affiliations" element={< Institutions />} />
						<Route path="/authors" element={< Researchers />} />

						<Route path="/profile" element={<Profile />} />

						{/* others  */}
						<Route path="/feedback" element={<FeedbackAndSuggestions />} />
						<Route path="/testimonials" element={<Testimonials />} />
						<Route path="/contact-us" element={<ContactUs />} />
						<Route path="/general-resources" element={<GeneralResources />} />


						{/* 404 Page - Catch all route */}
						<Route path="*" element={<NotFoundPage />} />
				</Routes>
			</Router>
		</ThemeProvider>
		</SnackbarProvider>
);}

export default App;
